module.exports = __webpack_public_path__ + "static/media/3.e086b3a2.jpeg";